import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const AppleIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path
        fillRule="evenodd"
        d="M10.81 8.434c.02 2.03 1.78 2.705 1.8 2.714-.015.048-.281.967-.924 1.914-.556.82-1.133 1.637-2.042 1.654-.893.017-1.18-.53-2.201-.53-1.02 0-1.34.514-2.185.547-.88.033-1.55-.883-2.11-1.701-1.143-1.67-2.016-4.72-.843-6.766.583-1.016 1.625-1.66 2.755-1.676.86-.017 1.673.58 2.2.58.528 0 1.52-.718 2.562-.612.436.018 1.661.176 2.448 1.328-.064.04-1.46.851-1.46 2.548Zm-1.456-4.26c.467-.567.782-1.355.696-2.14-.673.028-1.487.448-1.97 1.015-.433.502-.81 1.305-.708 2.076.75.058 1.515-.383 1.982-.95Z"
      />
    </CustomIcon>
  )
}
